'use strict'
import { request } from '../../plugins/http'

export default async ( arrayTerms ) => {
    return await request.post('/traducao', {items:JSON.stringify(arrayTerms)})
}